import { AccessGuard } from '@app/access/access-guard';
import { EAccess } from '@app/access/access.model';

import { MenuItem, MenuNode } from './menu.model';

export const DashboardMenuItem: [string, MenuNode] = [
  'MENUITEMS.DASHBOARD.TEXT',
  {
    icon: 'bx-home-circle',
    link: '/dashboard',
    isRoot: true
  }
];

export const ProjectMenuItem: [string, MenuNode] = [
  'MENUITEMS.PROJECTS.TEXT',
  {
    icon: 'bxs-book',
    access: EAccess.EvideProject,
    link: '/my-projects/list',
    isRoot: true
  }
];

export const FormMenuItem: [string, MenuNode] = [
  'MENUITEMS.MYFORMS.TEXT',
  {
    icon: 'bxs-notepad',
    access: EAccess.EvideInputContentForm,
    link: '/my-forms',
    isRoot: true
  }
];

export const ContactMenuItem: [string, MenuNode] = [
  'MENUITEMS.MYCONTACTS.TEXT', // Changing to young people for license 3 is covered
  {
    icon: 'bxs-user-detail',
    access: EAccess.Contact,
    link: '/my-contacts',
    isRoot: true
  }
];

export const WaitingListMenuItem: [string, MenuNode] = [
  'MENUITEMS.WAITINGLIST.TEXT',
  {
    icon: 'bx-list-ul',
    access: EAccess.WaitingList,
    link: '/waiting-list',
    isRoot: true
  }
];

export const HighRiskAlertsMenuItem: [string, MenuNode] = [
  'MENUITEMS.HIGHRISKALERTS.TEXT',
  {
    icon: 'bxs-bell-ring',
    access: EAccess.FormTriggerAlert,
    link: '/high-risk-alerts',
    isRoot: true
  }
];

export const ApprovalsMenuItem: [string, MenuNode] = [
  'Approvals',
  {
    icon: 'bx-check-shield',
    access: EAccess.WorkflowRequest,
    link: '/approvals',
    isRoot: true
  }
];

export const ActionPlanMenuItem: [string, MenuNode] = [
  'Action Plans',
  {
    icon: 'bx-task',
    access: EAccess.ActionPlan,
    link: '/action-plan',
    isRoot: true
  }
];

export const NonCaseLoadMenuItem: [string, MenuNode] = [
  'MENUITEMS.NONCASELOAD.TEXT',
  {
    icon: 'bx-clipboard',
    access: EAccess.NonCaseLoad,
    link: '/non-case-load',
    isRoot: true
  }
];

export const HelplineMenuItem: [string, MenuNode] = [
  'MENUITEMS.HELPLINE.TEXT',
  {
    icon: 'bx-phone-call',
    access: EAccess.Helpline,
    link: '/helpline',
    isRoot: true
  }
];

export const PropertiesMenuItem: [string, MenuNode] = [
  'MENUITEMS.PROPERTIES.TEXT',
  {
    icon: 'bx-building-house',
    access: EAccess.Property,
    link: '/properties',
    isRoot: true
  }
];

export const FamilyMenuItem: [string, MenuNode] = [
  'MENUITEMS.FAMILY.TEXT',
  {
    icon: 'bxs-group',
    access: EAccess.Family,
    link: '/families',
    isRoot: true
  }
];

export const ProgramMenuItem: [string, MenuNode] = [
  'MENUITEMS.PROGRAMS.TEXT',
  {
    icon: 'bx-book-content',
    access: EAccess.Program,
    link: '/program',
    isRoot: true
  }
];

export const ActivityMenuItem: [string, MenuNode] = [
  'MENUITEMS.MYACTIVITIES.TEXT',
  {
    icon: 'bx-command',
    access: EAccess.Activity,
    link: '/my-activities',
    isRoot: true
  }
];
export const EventsMenuItem: [string, MenuNode] = [
  'MENUITEMS.EVENTS.TEXT',
  {
    icon: 'bx-calendar-event',
    access: EAccess.Program,
    link: '/program-events',
    isRoot: true
  }
];

export const ScheduleMenuItem: [string, MenuNode] = [
  'MENUITEMS.MYSCHEDULES.TEXT',
  {
    icon: 'bx-calendar',
    access: EAccess.MySchedule,
    link: '/my-schedules',
    isRoot: true
  }
];

export const QuestionnaireMenuItem: [string, MenuNode] = [
  'MENUITEMS.QUESTIONNAIRES.TEXT',
  {
    icon: 'bx-file',
    access: EAccess.Questionnaire,
    link: '/questionnaires',
    isRoot: true
  }
];

export const ReportMenuItem: [string, MenuNode] = [
  'MENUITEMS.REPORTS.TEXT',
  {
    icon: 'bxs-report',
    access: EAccess.Reports,
    link: '/reports',
    isRoot: true
  }
];

export const OrganisationMenuItem: [string, MenuNode] = [
  'MENUITEMS.ORGANIZATIONS.TEXT',
  {
    icon: 'bxs-building',
    access: EAccess.Organisation,
    link: '/organisations',
    isRoot: true
  }
];

export const AdminMenuItems: Array<[string, MenuNode]> = [
  [
    'MENUITEMS.ADMIN.TEXT',
    {
      icon: 'person',
      isTitle: true
    }
  ],
  [
    'MENUITEMS.LICENSES.TEXT',
    {
      icon: 'bx-copyright',
      link: '/license',
      access: EAccess.EvideLicense,
      isRoot: true
    }
  ],
  [
    'Project Usage',
    {
      icon: 'bx-bar-chart-alt-2',
      link: '/my-projects/usage',
      isProjectAdminOrAbove: true,
      isRoot: true
    }
  ],
  [
    'MENUITEMS.CONSTANTS.TEXT',
    {
      icon: 'bx-sitemap',
      link: '/constant-type',
      access: EAccess.ConstantType,
      isRoot: true
    }
  ],
  [
    'MENUITEMS.SHARINGAUDIT.TEXT',
    {
      icon: 'bx-share-alt',
      link: '/sharing-audit',
      access: EAccess.SessionShare,
      isRoot: true
    }
  ],
  // [
  //     'MENUITEMS.FORMSETTINGS.TEXT',
  //     {
  //         icon: 'bxs-cog',
  //         isRoot: true,
  //         children: [
  //             // 'MENUITEMS.FORMSETTINGS.LIST.RULES',
  //             'MENUITEMS.FORMSETTINGS.LIST.INPUTCONTENT'
  //         ]
  //     }
  // ],
  [
    'MENUITEMS.FORMSETTINGS.LIST.RULES',
    {
      icon: 'bxs-badge-check',
      link: '/rule',
      access: EAccess.Rule,
      isRoot: true
    }
  ],
  [
    'MENUITEMS.FORMSETTINGS.LIST.INPUTCONTENT',
    {
      icon: 'bxs-cog',
      access: EAccess.InputContent,
      link: '/input-content',
      isRoot: true
    }
  ],
  [
    'MENUITEMS.RISKALERTS.TEXT',
    {
      icon: 'bxs-bell-plus',
      access: EAccess.FormTrigger,
      link: '/form-triggers',
      isRoot: true
    }
  ],
  [
    'MENUITEMS.NOTIFICATIONSETTINGS.TEXT',
    {
      icon: 'bxs-bell-plus',
      children: [
        'MENUITEMS.NOTIFICATIONSETTINGS.LIST.PARAMETERTYPES',
        'MENUITEMS.NOTIFICATIONSETTINGS.LIST.RULES',
        'MENUITEMS.NOTIFICATIONSETTINGS.LIST.TEMPLATES',
        'MENUITEMS.NOTIFICATIONSETTINGS.LIST.EVENTS'
      ],
      isRoot: true
    }
  ],
  [
    'MENUITEMS.NOTIFICATIONSETTINGS.LIST.PARAMETERTYPES',
    {
      access: EAccess.NotificationParameterType,
      link: 'notification-settings/parameter-types'
    }
  ],
  [
    'MENUITEMS.NOTIFICATIONSETTINGS.LIST.RULES',
    {
      link: '/notification-settings/rules',
      access: EAccess.NotificationRule
    }
  ],
  [
    'MENUITEMS.NOTIFICATIONSETTINGS.LIST.TEMPLATES',
    {
      link: '/notification-settings/templates',
      access: EAccess.NotificationEvent
    }
  ],
  [
    'MENUITEMS.NOTIFICATIONSETTINGS.LIST.EVENTS',
    {
      link: '/notification-settings/events',
      access: EAccess.NotificationEvent
    }
  ],
  [
    'MENUITEMS.USERS.TEXT',
    {
      icon: 'bxs-user',
      link: '/users',
      access: EAccess.User,
      isRoot: true
    }
  ],
  [
    'MENUITEMS.ROLES.TEXT',
    {
      icon: 'bxs bx-layer',
      link: '/roles',
      access: EAccess.Role,
      isRoot: true
    }
  ],
  [
    'MENUITEMS.ERRORS.TEXT',
    {
      icon: 'bx-error-circle',
      link: '/errors',
      access: EAccess.ErrorQueue,
      isRoot: true
    }
  ]
];

export const toMenuItem = (label: string, node: MenuNode): MenuItem => {
  const { icon, link, isTitle, badge } = node;
  return {
    icon,
    label,
    link,
    isTitle,
    badge,
    subItems: []
  };
};

export const hasMenuNodeAccess = (
  menuNodeKey: string,
  allMenuMap: Map<string, MenuNode>
): boolean => {
  const menuNode = allMenuMap.get(menuNodeKey);
  if (!menuNode) return false;
  if (AccessGuard.hasAccess(menuNode.access as EAccess) && !menuNode.children) {
    return true;
  } else if (menuNode.children?.length) {
    return menuNode.children.some((childrenKey) =>
      hasMenuNodeAccess(childrenKey, allMenuMap)
    );
  } else {
    return false;
  }
};

export const prepareMenuItem = (
  key: string,
  menuMap: Map<string, MenuNode>
): MenuItem | undefined => {
  if (!hasMenuNodeAccess(key, menuMap)) {
    return;
  }
  const menuNode = menuMap.get(key);
  if (!menuNode) return;
  if (menuNode.isRoot) {
    const menuItem: MenuItem = toMenuItem(key, menuNode);
    menuNode.children?.forEach((childKey) => {
      const childNode = menuMap.get(childKey);
      if (childNode && hasMenuNodeAccess(childKey, menuMap)) {
        menuItem.subItems?.push(toMenuItem(childKey, childNode));
      }
    });
    return menuItem;
  }
  if (menuNode.isTitle) {
    return toMenuItem(key, menuNode);
  }
};
